import { HttpHeaders, HttpParameterCodec } from '@angular/common/http';
import { CustomHttpParameterCodec } from './encoder';

export interface ConfigurationParameters {
  basePath?: string;
  withCredentials?: boolean;
  encoder?: HttpParameterCodec;
  credentials?: Record<string, string | (() => string | undefined)>;
}

export class Configuration {
  basePath?: string;
  withCredentials?: boolean;
  encoder?: HttpParameterCodec;
  credentials: Record<string, string | (() => string | undefined)>;

  constructor({ basePath, credentials, encoder, withCredentials }: ConfigurationParameters = {}) {
    if (basePath !== undefined) {
      this.basePath = basePath;
    }
    if (withCredentials !== undefined) {
      this.withCredentials = withCredentials;
    }
    this.encoder = encoder ?? new CustomHttpParameterCodec();
    this.credentials = credentials ?? {};
  }

  selectHeaderAccept(accepts: string[]): string | undefined {
    if (accepts.length === 0) {
      return undefined;
    }
    const json = accepts.find((x) => x.includes('json'));
    return json ?? accepts[0];
  }

  lookupCredential(key: string): string | undefined {
    const value = this.credentials[key];
    return typeof value === 'function' ? value() : value;
  }

  addCredentialToHeaders(credentialKey: string, headerName: string, headers: HttpHeaders): HttpHeaders {
    const value = this.lookupCredential(credentialKey);
    return value ? headers.set(headerName, value) : headers;
  }
}
